import { render } from "./billManage copy.vue?vue&type=template&id=30836c60&scoped=true"
import script from "./billManage copy.vue?vue&type=script&lang=js"
export * from "./billManage copy.vue?vue&type=script&lang=js"

import "./billManage copy.vue?vue&type=style&index=0&id=30836c60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30836c60"]])

export default __exports__